import { post, put, remove } from '../Services/http';
import { load as loadCart } from './Cart.action';
import { catchError } from './Error.action';
import { queueShippingUpdate } from '../Services/unifaunShippingUpdates';

export const CHECKOUT_SET_SELECTED_COMPANY_ADDRESS = 'CHECKOUT_SET_SELECTED_COMPANY_ADDRESS';
export const CHECKOUT_SET_CUSTOMER_INFO = 'CHECKOUT_SET_CUSTOMER_INFO';
export const CHECKOUT_SET_PRIVATE_CUSTOMER = 'CHECKOUT_SET_PRIVATE_CUSTOMER';
export const CHECKOUT_SET_SIGN_UP = 'CHECKOUT_SET_SIGN_UP';
export const CHECKOUT_SET_DELIVERY = 'CHECKOUT_SET_DELIVERY';
export const CHECKOUT_SET_COUNTRY = 'CHECKOUT_SET_COUNTRY';
export const CHECKOUT_SET_PAYMENT = 'CHECKOUT_SET_PAYMENT';
export const CHECKOUT_SET_CAMPAIGN_CODE = 'CHECKOUT_SET_CAMPAIGN_CODE';
export const CHECKOUT_SET_ORDER_NOTE = 'CHECKOUT_SET_ORDER_NOTE';
export const CHECKOUT_ACCEPT_TERMS_OF_CONDITION = 'CHECKOUT_ACCEPT_TERMS_OF_CONDITION';
export const CHECKOUT_SUBMIT = 'CHECKOUT_SUBMIT';
export const CHECKOUT_SUBMIT_DONE = 'CHECKOUT_SUBMIT_DONE';
export const CHECKOUT_SUBMIT_ERROR = 'CHECKOUT_SUBMIT_ERROR';
export const CHECKOUT_SET_PAYMENT_WIDGET = 'CHECKOUT_SET_PAYMENT_WIDGET';
export const CHECKOUT_SET_SHIPPING_OPTION = 'CHECKOUT_SET_SHIPPING_OPTION';
export const CHECKOUT_SET_DISCOUNT_CODE = 'CHECKOUT_SET_DISCOUNT_CODE';
export const CHECKOUT_SET_USED_DISCOUNT_CODE = 'CHECKOUT_SET_USED_DISCOUNT_CODE';
export const CHECKOUT_SET_STATUS_SUBMIT_BUTTON = 'CHECKOUT_SET_STATUS_SUBMIT_BUTTON';
export const CHECKOUT_SET_SHIPMENT_WIDGET = 'CHECKOUT_SET_SHIPMENT_WIDGET';
export const CHECKOUT_SET_UNIFAUN_SELECTED_SHIPPING_RESULT = 'CHECKOUT_SET_UNIFAUN_SELECTED_SHIPPING_RESULT';
export const CHECKOUT_SET_UNIFAUN_LOADING = 'CHECKOUT_SET_UNIFAUN_LOADING';
export const CHECKOUT_SET_UNIFAUN_DELIVERY_CHECKOUT = 'CHECKOUT_SET_UNIFAUN_DELIVERY_CHECKOUT';
export const CHECKOUT_SET_UNIFAUN_ZIPCODE = 'CHECKOUT_SET_UNIFAUN_ZIPCODE';
export const CHECKOUT_SET_QLIRO_CUSTOMER_INFO = 'CHECKOUT_SET_QLIRO_CUSTOMER_INFO';
export const CHECKOUT_SET_DELIVERY_FORMAT = 'CHECKOUT_SET_DELIVERY_FORMAT';
export const CHECKOUT_SET_UNIFAUN_DELIVERY_CHECKOUTS = 'CHECKOUT_SET_UNIFAUN_DELIVERY_CHECKOUTS';
export const CHECKOUT_SET_UNIFAUN_SELECTED_SHIPPING_FOR_GROUP = 'CHECKOUT_SET_UNIFAUN_SELECTED_SHIPPING_FOR_GROUP';
export const CHECKOUT_SET_UNIFAUN_DELIVERY_GROUPS = 'CHECKOUT_SET_UNIFAUN_DELIVERY_GROUPS';

export const setBusinessCustomer = (isBusinessCustomer) => ({
    type: CHECKOUT_SET_PRIVATE_CUSTOMER,
    payload: {
        isBusinessCustomer,
    }
});

export const setSignUp = (signUp, abortController = null) => (dispatch) => {
    const payload = { signUp };
    return put('/api/checkout/signUp', payload, abortController)
        .then((response) => response.json())
        .then((result) => {
            dispatch({
                type: CHECKOUT_SET_SIGN_UP,
                payload: {
                    signUp: result.signUp,
                }
            });
        })
        .catch((ex) => dispatch(catchError(ex, (error) => submitError(error))));
};

export const updateCustomerDetails = (key, data) => ({
    type: CHECKOUT_UPDATE_CUSTOMER_INFO,
    payload: {
        key,
        data,
    },
});

export const setAlternativeAddress = (propName, value) => ({
    type: CHECKOUT_SET_CUSTOMER_INFO,
    payload: {
        key: 'alternativeAddress',
        data: {
            [propName]: value,
        },
    }
});

export const setCustomerDetails = (propName, value) => ({
    type: CHECKOUT_SET_CUSTOMER_INFO,
    payload: {
        key: 'customerDetails',
        data: {
            [propName]: value,
        },
    }
});

export const setSelectedCompanyAddress = (selectedCompanyAddressId) => ({
    type: CHECKOUT_SET_SELECTED_COMPANY_ADDRESS,
    payload: {
        selectedCompanyAddressId,
    }
});

export const setDelivery = (method) => (dispatch, getState) => {
    dispatch({
        type: CHECKOUT_SET_DELIVERY,
        payload: {
            selectedDeliveryMethod: method,
        },
    });
    const { payload } = getState().checkout;
    return put('/api/checkout/setDeliveryProvider', payload)
        .then((response) => response.json())
        .then((result) => {
            dispatch(loadCart());
            if (result !== null && result.paymentWidget) {
                dispatch(setPaymentWidget(result.paymentWidget));
            }
            dispatch(setShipmentWidget(result.shipmentWidget));
            dispatch(setSelectedShippingOption(null));
        })
        .catch((ex) => dispatch(catchError(ex, (error) => submitError(error))));
};

export const setShippingOption = (shippingOption) => (dispatch, getState) => {
    dispatch({
        type: CHECKOUT_SET_SHIPPING_OPTION,
        payload: {
            klarnaSelectedShippingOption: shippingOption,
        }
    });
    const { payload } = getState().checkout;
    return put('/api/klarnacheckout/setShippingOption', payload)
        .then(response => response.json())
        .then(result => {
            dispatch(loadCart());
            if (result !== null && result.paymentWidget !== null) {
                dispatch(setPaymentWidget(result.paymentWidget));
            }
        })
        .catch(ex => dispatch(catchError(ex, error => submitError(error))))
};

export const updateUnifaunSelectedShippingResult = (unifaunSelectedShipping) => (dispatch, getState) => {
    dispatch(setUnifaunSelectedShippingResult(unifaunSelectedShipping));
    // Queued so results from the nShift widget are never persisted out of order, see
    // Services/unifaunShippingUpdates.
    return queueShippingUpdate('', () => {
        const { payload } = getState().checkout;
        return put('/api/checkout/setShippingOption', payload)
            .then(response => response.json())
            .then(result => {
                dispatch(loadCart());
                if (result !== null && result.paymentWidget !== null) {
                    dispatch(setPaymentWidget(result.paymentWidget));
                }
            })
            .catch(ex => dispatch(catchError(ex, error => submitError(error))));
    });
};

export const setUnifaunSelectedShippingResult = (unifaunSelectedShipping) => ({
    type: CHECKOUT_SET_UNIFAUN_SELECTED_SHIPPING_RESULT,
    payload: {
        unifaunSelectedShipping,
    },
});

export const getUnifaunDeliveryCheckout = (zipCode) => (dispatch, getState) => {
    dispatch(setUnifaunLoading(true));
    dispatch(setUnifaunZipCode(zipCode));
    const { payload } = getState().checkout;
    return put('/api/checkout/unifaunDeliveryCheckout', payload)
        .then(response => response.json())
        .then(result => {
            if (result !== null && result.deliveryCheckout !== null) {
                dispatch(setUnifaunDeliveryCheckout(result.deliveryCheckout));
            }
        })
        .catch(ex => dispatch(catchError(ex, error => submitError(error))))
        .finally(() => dispatch(setUnifaunLoading(false)));
};

export const setUnifaunLoading = (unifaunLoading) => ({
    type: CHECKOUT_SET_UNIFAUN_LOADING,
    payload: {
        unifaunLoading,
    },
});

export const setUnifaunDeliveryCheckout = (unifaunDeliveryCheckout) => ({
    type: CHECKOUT_SET_UNIFAUN_DELIVERY_CHECKOUT,
    payload: {
        unifaunDeliveryCheckout,
    },
});

export const setUnifaunZipCode = (unifaunZipCode) => ({
    type: CHECKOUT_SET_UNIFAUN_ZIPCODE,
    payload: {
        unifaunZipCode,
    },
});

export const getUnifaunDeliveryCheckouts = (zipCode) => (dispatch) => {
    dispatch(setUnifaunLoading(true));
    dispatch(setUnifaunZipCode(zipCode));
    return put('/api/checkout/unifaunDeliveryCheckouts', { unifaunZipCode: zipCode })
        .then(response => response.json())
        .then(result => {
            if (result !== null) {
                dispatch({
                    type: CHECKOUT_SET_UNIFAUN_DELIVERY_CHECKOUTS,
                    payload: { unifaunDeliveryCheckouts: result.deliveryCheckouts },
                });
                dispatch({
                    type: CHECKOUT_SET_UNIFAUN_DELIVERY_GROUPS,
                    payload: { unifaunDeliveryGroups: result.groups },
                });
            }
        })
        .catch(ex => dispatch(catchError(ex, error => submitError(error))))
        .finally(() => dispatch(setUnifaunLoading(false)));
};

export const updateUnifaunSelectedShippingForGroup = (groupKey, unifaunSelectedShipping) => (dispatch, getState) => {
    dispatch({
        type: CHECKOUT_SET_UNIFAUN_SELECTED_SHIPPING_FOR_GROUP,
        payload: { groupKey, unifaunSelectedShipping },
    });
    // Queued per group so results from the nShift widget are never persisted out of order,
    // see Services/unifaunShippingUpdates.
    return queueShippingUpdate(groupKey, () => {
        const { payload } = getState().checkout;
        return put('/api/checkout/setShippingOption', {
            ...payload,
            unifaunSelectedShipping: unifaunSelectedShipping,
            unifaunShippingGroupKey: groupKey,
        })
            .then(response => response.json())
            .then(result => {
                dispatch(loadCart());
                if (result !== null && result.paymentWidget !== null) {
                    dispatch(setPaymentWidget(result.paymentWidget));
                }
            })
            .catch(ex => dispatch(catchError(ex, error => submitError(error))));
    });
};

export const setCountry = (systemId) => (dispatch, getState) => {
    dispatch({
        type: CHECKOUT_SET_COUNTRY,
        payload: {
            selectedCountry: systemId,
        }
    });
    const { payload } = getState().checkout;

    // reset paymentWidget to null to avoid sending unnecessary request to payment provider
    dispatch(setPaymentWidget(null));
    dispatch(setShipmentWidget(null));

    return put('/api/checkout/setCountry', payload)
        .then(response => response.json())
        .then(result => {
            dispatch(loadCart());
            dispatch(setPaymentWidget(result.paymentWidget));
            dispatch(setShipmentWidget(result.shipmentWidget));
            dispatch({
                type: CHECKOUT_SET_DELIVERY,
                payload: {
                    deliveryMethods: result.deliveryMethods,
                    selectedDeliveryMethod: result.selectedDeliveryMethod,
                }
            });
            dispatch({
                type: CHECKOUT_SET_PAYMENT,
                payload: {
                    paymentMethods: result.paymentMethods,
                    selectedPaymentMethod: result.selectedPaymentMethod,
                }
            });
        })
        .catch(ex => dispatch(catchError(ex, error => submitError(error))))
};

export const setPayment = (systemId) => (dispatch, getState) => {
    dispatch({
        type: CHECKOUT_SET_PAYMENT,
        payload: {
            selectedPaymentMethod: systemId,
        }
    });
    const { payload } = getState().checkout;
    return put('/api/checkout/setPaymentProvider', payload)
        .then(response => response.json())
        .then(result => {
            dispatch(loadCart());
            dispatch(setPaymentWidget(result.paymentWidget));
        })
        .catch(ex => dispatch(catchError(ex, error => submitError(error))))
};

export const reloadPayment = () => (dispatch, getState) => {
    const { payload } = getState().checkout;
    return put('/api/checkout/reloadPaymentWidget', payload)
        .then((response) => response.json())
        .then((result) => {
            if (result && result.paymentWidget) {
                dispatch(setPaymentWidget(result.paymentWidget));
            }
        })
        .catch((ex) => dispatch(catchError(ex, (error) => submitError(error))));
};

export const reloadShipment = () => (dispatch, getState) => {
    const { payload } = getState().checkout;
    return put('/api/checkout/reloadShipmentWidget', payload)
        .then((response) => response.json())
        .then((result) => {
            if (result && result.shipmentWidget) {
                dispatch(setShipmentWidget(result.shipmentWidget));
            }
        })
        .catch((ex) => dispatch(catchError(ex, (error) => submitError(error))));
};

const setSelectedShippingOption = (shippingInfo) => ({
    type: CHECKOUT_SET_SHIPPING_OPTION,
    payload: {
        shippingInfo,
    },
});

const setPaymentWidget = (paymentWidget) => ({
    type: CHECKOUT_SET_PAYMENT_WIDGET,
    payload: {
        paymentWidget,
    }
});

const setShipmentWidget = (shipmentWidget) => ({
    type: CHECKOUT_SET_SHIPMENT_WIDGET,
    payload: {
        shipmentWidget,
    },
});

export const setOrderNote = (orderNote) => ({
    type: CHECKOUT_SET_ORDER_NOTE,
    payload: {
        orderNote,
    }
});

export const acceptTermsOfCondition = (acceptTermsOfCondition) => ({
    type: CHECKOUT_ACCEPT_TERMS_OF_CONDITION,
    payload: {
        acceptTermsOfCondition,
    }
});

export const setDiscountCode = (discountCode) => ({
    type: CHECKOUT_SET_DISCOUNT_CODE,
    payload: {
        discountCode,
    },
});

export const submitDiscountCode = () => (dispatch, getState) => {
    const { payload } = getState().checkout;
    return put('/api/checkout/setDiscountCode', payload)
        .then((response) => response.json())
        .then((result) => {
            dispatch(setUsedDiscountCodes(result.usedDiscountCodes));
            dispatch(loadCart());
            if (result && result.shipmentWidget) {
                dispatch(setShipmentWidget(result.shipmentWidget));
            }
            dispatch(setPaymentWidget(result.paymentWidget));
            // reset error of campaign code
            dispatch(
                submitError({
                    modelState: {
                        discountCode: [],
                    },
                })
            );
        })
        .catch((ex) => {
            dispatch(catchError(ex, (error) => submitError(error)));
            // restore the initial cart
            dispatch(loadCart());
        });
};

export const deleteDiscountCode = (discountCode) => (dispatch, getState) => {
    const { payload } = getState().checkout;
    payload.discountCode = discountCode;
    return remove('/api/checkout/deleteDiscountCode', payload)
        .then((response) => response.json())
        .then((result) => {
            dispatch(setUsedDiscountCodes(result.usedDiscountCodes));
            dispatch(loadCart());
            if (result && result.shipmentWidget) {
                dispatch(setShipmentWidget(result.shipmentWidget));
            }
            dispatch(setPaymentWidget(result.paymentWidget));
            dispatch(setDiscountCode(''));
            // reset error of campaign code
            dispatch(
                submitError({
                    modelState: {
                        discountCode: [],
                    },
                })
            );
        })
        .catch((ex) => {
            dispatch(catchError(ex, (error) => submitError(error)));
            // restore the initial cart
            dispatch(loadCart());
        });
};

const setUsedDiscountCodes = (usedDiscountCodes) => ({
    type: CHECKOUT_SET_USED_DISCOUNT_CODE,
    payload: {
        usedDiscountCodes,
    },
});

export const submit = () => (dispatch, getState) => {
    const { payload } = getState().checkout;
    return _submit('/api/checkout', payload, dispatch);
};

export const verify = (url, orderId, payload) => (dispatch, getState) => {
    const model = getState().checkout.payload;
    model.orderId = orderId;
    model.payload = payload;
    return _submit(url, model, dispatch);
};

const _submit = (url, model, dispatch) => {
    return post(url, model)
        .then(response => response.json())
        .then(result => {
            dispatch(submitDone(result));
        })
        .catch(ex => {
            if (ex.response) {
                ex.response.json().then(error => {
                    dispatch(submitError(error));
                    dispatch(submitDone(null));
                    // reload the cart, it might be changed after validation
                    dispatch(loadCart());
                });
            } else {
                dispatch(submitError(ex));
            }
        })
    ;
};

export const saveCustomerDetail = (data) => (dispatch, getState) => {
    const { payload } = getState().checkout;
    const updatedData = { ...payload, ...data };
    return put('/api/checkout/setCustomerDetail', updatedData)
        .then((response) => response.json())
        .then(() => dispatch(setStatusSubmitButton(true)))
        .catch((ex) => {
            if (ex.response) {
                ex.response.json().then((error) => {
                    dispatch(submitError(error));
                    dispatch(setStatusSubmitButton(false));
                });
            } else {
                dispatch(submitError(ex));
            }
            throw ex;
        });
};

export const clearError = () => ({
    type: CLEAR_ERROR,
    payload: {
        errors: [],
    },
});

export const submitRequest = () => ({
    type: CHECKOUT_SUBMIT,
    payload: {
        isSubmitting: true,
        errors: [],
    },
});

export const submitDone = result => ({
    type: CHECKOUT_SUBMIT,
    payload: {
        result,
        isSubmitting: false,
    },
});

export const submitError = error => ({
    type: CHECKOUT_SUBMIT_ERROR,
    payload: {
        error,
    },
});

export const setStatusSubmitButton = (value) => ({
    type: CHECKOUT_SET_STATUS_SUBMIT_BUTTON,
    payload: {
        enableConfirmButton: value,
    },
});

export const setValidateStatus = (isValidating) => ({
    type: CHECKOUT_VALIDATE_ADDRESS,
    payload: {
        isValidating,
    },
});

export const setDeliveryFormat = (splitDelivery) => (dispatch, getState) => {
    dispatch({
        type: CHECKOUT_SET_DELIVERY_FORMAT,
        payload: {
            splitDelivery,
        },
    });
    // Clear all Unifaun selections when delivery format changes
    dispatch({
        type: CHECKOUT_SET_UNIFAUN_DELIVERY_CHECKOUTS,
        payload: { unifaunDeliveryCheckouts: {} },
    });
    dispatch({
        type: CHECKOUT_SET_UNIFAUN_DELIVERY_GROUPS,
        payload: { unifaunDeliveryGroups: [] },
    });
    dispatch(setUnifaunSelectedShippingResult({ valid: false }));
    dispatch(setUnifaunLoading(true));
    return put('/api/checkout/setDeliveryFormat', { splitDelivery })
        .then(() => {
            dispatch(reloadPayment());
            const { cart, checkout } = getState();
            const zipcode = checkout.payload.unifaunZipCode;
            if (zipcode) {
                if (splitDelivery && cart.hasMixedDelivery) {
                    return dispatch(getUnifaunDeliveryCheckouts(zipcode));
                }
                return dispatch(getUnifaunDeliveryCheckout(zipcode));
            }
        })
        .catch((ex) => dispatch(catchError(ex, (error) => submitError(error))))
        .finally(() => dispatch(setUnifaunLoading(false)));
};

export const saveQliroCustomerInfo = (qliroCustomerInfo) => (dispatch, getState) => {
    dispatch(setQliroCustomerInfo(qliroCustomerInfo));
    const { payload } = getState().checkout;
    return put('/api/checkout/saveQliroCustomerInfo', payload)
        .catch((ex) => dispatch(catchError(ex, (error) => submitError(error))));
};

export const setQliroCustomerInfo = (qliroCustomerInfo) => ({
    type: CHECKOUT_SET_QLIRO_CUSTOMER_INFO,
    payload: {
        qliroCustomerInfo,
    },
});
